"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relativeToDateRangeWindow = void 0;
var dateUtils_1 = require("../../dateUtils");
var engine_1 = require("../../engine");
var models_1 = require("../../models");
var Accessor_1 = require("../../models/Accessor");
var relativeToDateRangeWindow = function (table, relativeWindow, accessor) {
    if (accessor === void 0) { accessor = Accessor_1.DefaultTimestampAccessor; }
    if (relativeWindow.unit === models_1.DateTrunc.NONE || relativeWindow.unit === models_1.DateTrunc.UNKNOWN) {
        return undefined;
    }
    var lastPoint = (0, engine_1.getLatestValue)(table);
    if (!lastPoint || !accessor(lastPoint)) {
        return undefined;
    }
    else {
        return (0, dateUtils_1.rangeRelativeToDate)(accessor(lastPoint), relativeWindow);
    }
};
exports.relativeToDateRangeWindow = relativeToDateRangeWindow;
//# sourceMappingURL=relativeToDateRangeWindow.js.map